import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { multiBookingWarning } from './helper';

import { DialogBox, useDialog, mapDialogMessage } from '../../../comps/dialog';
import { receiveCrosstabWarning, closeCrosstabWarning } from '../../../helpers/crosstab-warning';
import { logEvent } from '../../../helpers';

// import { channel, sendCrosstabWarning} from './channel';

function CrosstabWarning() {

  const dialog = useDialog("Multiple Booking", "You have an active booking in another tab or window");

  useEffect(() => {

    receiveCrosstabWarning((data, myBooking) => {
      if(data.type !== 'mmb' || !data.pnr || !myBooking || data.pnr !== myBooking) return;

      const message = multiBookingWarning.replace('{0}', data.pnr);
      dialog.show(message)
      .then(() => {
        logEvent({
          eventName: 'crosstab warning acknowledged',
          details: { pnr: data.pnr, path: data.path }
        });
      })
      .catch(() => {});
    });

    return () => {
      closeCrosstabWarning(); 
    }
  }, []);


  return (
    <DialogBox open={dialog.open} title={dialog.title} closeButtonText={'Confirm'} onClose={dialog.close} hideCancelButton={true}>
      { mapDialogMessage(dialog.message) }
    </DialogBox>
  )
}

export default withRouter(CrosstabWarning);